import { render, staticRenderFns } from "./ListMyList.vue?vue&type=template&id=245fb58a&scoped=true&"
import script from "./ListMyList.vue?vue&type=script&lang=js&"
export * from "./ListMyList.vue?vue&type=script&lang=js&"
import style0 from "./ListMyList.vue?vue&type=style&index=0&id=245fb58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245fb58a",
  null
  
)

export default component.exports